import { Injectable } from '@angular/core';
import { HttpHeaders, HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';


@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor() {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
       
            request = request.clone({
                
                headers: new HttpHeaders({
                    'Auth': `dHV0c3BsdXM6MTIzNDU2`
                    })
            });

        return next.handle(request);
    }
}